import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["splitter", [`splitter--${_ctx.direction}`, { 'splitter--dragging': _ctx.isDragging, 'splitter--collapsing': _ctx.isAnimating }]]),
        ref: "container"
    }, [
        _createElementVNode("div", {
            class: "splitter__pane splitter__pane--1",
            style: _normalizeStyle(_ctx.pane1Style)
        }, [
            (!_ctx.p1Collapsed)
                ? _renderSlot(_ctx.$slots, "pane-1", { key: 0 })
                : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", {
            class: _normalizeClass(["splitter__divider", { 'splitter__divider--hidden': _ctx.dividerHidden }]),
            onPointerdown: _cache[4] || (_cache[4] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.onDividerPointerDown && _ctx.onDividerPointerDown(...args)), ["prevent"]))
        }, [
            (_ctx.collapsible && _ctx.pane1Collapsible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "splitter__btn splitter__btn--start",
                    title: _ctx.$t(_ctx.p1Collapsed ? 'client.Splitter.Expand' : 'client.Splitter.Collaps'),
                    onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.togglePane1 && _ctx.togglePane1(...args)), ["stop"]))
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(["bi", _ctx.btnIcon1])
                    }, null, 2)
                ], 40, _hoisted_1))
                : _createCommentVNode("", true),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "splitter__grip" }, null, -1)),
            (_ctx.collapsible && _ctx.pane2Collapsible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "splitter__btn splitter__btn--end",
                    title: _ctx.$t(_ctx.p2Collapsed ? 'client.Splitter.Expand' : 'client.Splitter.Collaps'),
                    onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.togglePane2 && _ctx.togglePane2(...args)), ["stop"]))
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(["bi", _ctx.btnIcon2])
                    }, null, 2)
                ], 40, _hoisted_2))
                : _createCommentVNode("", true)
        ], 34),
        _createElementVNode("div", {
            class: "splitter__pane splitter__pane--2",
            style: _normalizeStyle(_ctx.pane2Style)
        }, [
            (!_ctx.p2Collapsed)
                ? _renderSlot(_ctx.$slots, "pane-2", { key: 0 })
                : _createCommentVNode("", true)
        ], 4)
    ], 2));
}
